var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaviconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    zoomAndPan: "magnify",
    viewBox: "0 0 1440 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(15.321217, 0, 0, 15.321217, 395.065153, 366.437346)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.499934 2.500117 L 29.426443 2.500117 ",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(15.321217, 0, 0, 15.321217, 719.99997, 161.358293)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.500109 2.499923 L 18.70823 2.499923 ",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(15.321217, 0, 0, 15.321217, 531.572787, 161.358293)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.499946 2.499923 L 6.694752 2.499923 ",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(15.321217, 0, 0, 15.321217, 531.572787, 565.61344)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.499946 2.500097 L 18.708066 2.500097 ",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(15.321217, 0, 0, 15.321217, 904.059393, 572.035527)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 2.500055 2.500083 L 6.694861 2.500083 ",
    stroke: "#ffffff",
    strokeWidth: 5,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaviconWhite);
export default __webpack_public_path__ + "static/media/Favicon_White.3d09381040306dd63dabfe9c8a783ede.svg";
export { ForwardRef as ReactComponent };